import { render, staticRenderFns } from "./KingdomDetailView.vue?vue&type=template&id=b668bf0c&scoped=true"
import script from "./KingdomDetailView.vue?vue&type=script&lang=js"
export * from "./KingdomDetailView.vue?vue&type=script&lang=js"
import style0 from "./KingdomDetailView.vue?vue&type=style&index=0&id=b668bf0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b668bf0c",
  null
  
)

export default component.exports